import React, { useRef, useState } from 'react';
import Text from '../../../../Components/Base/Text/Text';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';
// @ts-ignore
import styles from './PatientsGroupUpload.module.scss';
import InputWrapper from '../../../../Components/Form/components/InputWrapper/InputWrapper';
import { useController, useFormContext } from 'react-hook-form';
import ErrorMessage from '../../../../Components/Form/components/ErrorMessage';

const PatientsGroupUpload: React.FC = () => {
	const [fileName, setFileName] = useState<string | undefined>(undefined);
	const fileInput = useRef<any>(null);
	const { control } = useFormContext();
	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: 'file',
	});

	const handleOpenUpload = () => {
		fileInput.current.click();
	};

	const afterSelectFile = (val: any) => {
		const fileName = fileInput.current.value;
		setFileName(fileName.split('\\').pop());
	};

	return (
		<>
			<div className={styles.upload}>
				{fileName ? (
					<div className={styles.file}>
						<div className='d-flex flex-row align-items-center'>
							<div className='mr-3'>
								<img src='/dist/icons/file-icon.svg' alt='file icon' />
							</div>
							<div>
								<Text tx='base.selectedFile' firstUpper />
								<div
									className={styles.name}
									onClick={() => setFileName(undefined)}>
									{fileName}
								</div>
							</div>
						</div>
						<Button
							theme={Theme.BLUE}
							title='component.groupMsgs.chooseAnotherFile'
							className={styles.button}
							onClick={handleOpenUpload}
						/>
					</div>
				) : (
					<div className={styles.buttonTextWrapper}>
						<div className={styles.buttonWrapper}>
							<Button
								theme={Theme.BLUE}
								title='base.chooseFileToImport'
								className={styles.button}
								onClick={handleOpenUpload}
							/>
							{error?.message && <ErrorMessage tx={error.message} />}
						</div>
						<Text className={styles.hint} tx='component.groupMsgs.text1' />
					</div>
				)}
			</div>
			<InputWrapper className={styles.inputWrapper}>
				<input
					type='file'
					ref={fileInput}
					onInput={afterSelectFile}
					onChange={event => {
						// @ts-ignore
						field.onChange(event.target.files[0]);
					}}
				/>
			</InputWrapper>
		</>
	);
};

export default PatientsGroupUpload;
